import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    FormControl,
    FormLabel,
    Input,
    VStack,
    Heading,
    Text,
    Image,
    useToast,
    InputGroup,
    InputRightElement,
    IconButton
} from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { useAuth } from '../contexts/AuthContext';
import logo from './sldatatech.png';
import aisystems from './sldatatech_aisystems.png';

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { login } = useAuth();
    const toast = useToast();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            await login(username, password);
            toast({
                title: 'Login successful',
                status: 'success',
                duration: 3000,
            });
        } catch (error) {
            toast({
                title: 'Login failed',
                description: error.message,
                status: 'error',
                duration: 5000,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center">
            <Container maxW="md">
                <Box bg="white" p={8} borderRadius="lg" boxShadow="lg">
                    <VStack spacing={6} align="stretch">
                        {/* Logo Section - Same as ConversationList */}
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                        >
                            <Box as="a" href="https://sldatatech.com" target="_blank" rel="noopener noreferrer">
                                <Image
                                    src={logo}
                                    alt="SL Data Tech"
                                    mt={4}
                                    h={8}
                                    objectFit="contain"
                                />
                            </Box>
                            <Image
                                src={aisystems}
                                alt="AI systems"
                                h={4}
                                mt={2}
                                mb={1}
                                objectFit="contain"
                            />
                        </Box>

                        <form onSubmit={handleSubmit}>
                            <VStack spacing={4}>
                                <FormControl isRequired>
                                    <Input
                                        type="text"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        placeholder="Username"
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <InputGroup>
                                        <Input
                                            type={showPassword ? 'text' : 'password'}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            placeholder="Password"
                                        />
                                        <InputRightElement>
                                            <IconButton
                                                size="sm"
                                                variant="ghost"
                                                icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                                                onClick={() => setShowPassword(!showPassword)}
                                            />
                                        </InputRightElement>
                                    </InputGroup>
                                </FormControl>

                                <Button
                                    type="submit"
                                    colorScheme="brand"
                                    width="full"
                                    isLoading={isLoading}
                                >
                                    Sign In
                                </Button>
                            </VStack>
                        </form>
                    </VStack>
                </Box>
            </Container>
        </Box>
    );
}

export default Login;